import React, { useState } from 'react';
import Card from 'components/Card';
import EnhancedThemeProvider from 'components/EnhancedThemeProvider';
import PageHeaderIcon from 'components/PageHeaderIcon';
import SearchInput from 'components/SearchInput';
import DiscoverContent from './components/DiscoverContent';
import HowToContent from './components/HowToContent';
import ModeToggle from './components/ModeToggle';
import VideoModal from './components/VideoModal';
import { useGetLearningHubSettings } from './gql';
import {
  Container,
  HeaderContainer,
  HeaderContent,
  Title,
  ContentCard,
  ContentHeader,
  HeaderLeft,
} from './StyledComponents';

const LearningHub = () => {
  const [mode, setMode] = useState('discover');
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedVideo, setSelectedVideo] = useState(null);

  const { settings } = useGetLearningHubSettings();

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  return (
    <EnhancedThemeProvider>
      <Container>
        {/* Header Card */}
        <Card style={{ marginBottom: '30px' }}>
          <HeaderContainer>
            <PageHeaderIcon icon="learning" />
            <HeaderContent>
              <Title>Learning Hub</Title>
            </HeaderContent>
          </HeaderContainer>
        </Card>

        {/* Content Card */}
        <Card noPadding>
          <ContentCard>
            <ContentHeader>
              <HeaderLeft>
                <ModeToggle mode={mode} setMode={setMode} />
              </HeaderLeft>
              <SearchInput
                onSearch={handleSearch}
                placeholder="Search videos..."
                debounceMs={300}
              />
            </ContentHeader>

            {mode === 'discover' ? (
              <DiscoverContent
                searchQuery={searchQuery}
                onPlayVideo={setSelectedVideo}
              />
            ) : (
              <HowToContent
                searchQuery={searchQuery}
                onPlayVideo={setSelectedVideo}
              />
            )}
          </ContentCard>
        </Card>
      </Container>

      {/* Video Modal */}
      <VideoModal
        video={selectedVideo}
        onClose={() => setSelectedVideo(null)}
        mode={mode}
        helpBaseUrl={settings?.help_base_url}
      />
    </EnhancedThemeProvider>
  );
};

export default LearningHub;
